function DropdownArrowIcon() {
    return (
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                d="M8.15758 7.30677C7.3983 7.98612 6.24968 7.98612 5.4904 7.30677L1.22512 3.49046C-0.143018 2.26634 0.722878 -2.23966e-05 2.55871 -2.22361e-05L6.82399 -2.18633e-05L11.0893 -2.14904e-05C12.9251 -2.13299e-05 13.791 2.26634 12.4229 3.49046L8.15758 7.30677Z"
                fill="#D1CDC9"/>
        </svg>
    );
}

export default DropdownArrowIcon;
